module.exports = __webpack_public_path__ + "media/images/gimmicks/gimmick-snake-5bce93732468f1cd0b9b5f99c17a4293.svg";